export default __webpack_public_path__ + "static/media/collect-highlights.d2ad56540e9a8d9c56f1b52e9f54a225.svg";